import $ from "jquery";

//スクロールしたら表示
window.addEventListener("scroll", function () {
  const elm = document.querySelector(".js_pagetop");
  const scroll = window.pageYOffset;
  if (scroll > 300) {
    elm.classList.add("is-show");
  } else {
    elm.classList.remove("is-show");
  }
});
//クリックしたときの動き
$(function () {
  var topBtn = $(".js_pagetop");
  topBtn.click(function () {
    $("body,html").animate(
      {
        scrollTop: 0,
      },
      500
    );
    return false;
  });
});
